import { useMutation, useQueryClient } from "@tanstack/react-query";

import apiClient from "@app/common/api/apiClient";

import useIntegrations from "./useIntegrations";

const useSlackIntegration = () => {
  const queryClient = useQueryClient();
  const { getIntegration, isLoading } = useIntegrations();

  const disconnectSlackMutation = useMutation({
    mutationFn: apiClient.integrations.slack.removeSlackIntegration,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });

  const userIntegration = getIntegration({
    providerId: "slack_bot",
    scope: "user",
  })!;

  const workspaceIntegration = getIntegration({
    providerId: "slack_bot",
    scope: "workspace",
  })!;

  return {
    isLoading,
    isConnected:
      userIntegration.isConnected || workspaceIntegration.isConnected,
    userIntegration,
    workspaceIntegration,
    disconnect: disconnectSlackMutation,
  };
};

export default useSlackIntegration;
